// This file contains enums representing each Optimizely feature flag used by this webapp.

// Example:
// export enum ContentSource {
//   DX = 'dx',
//   NAME = 'cmspages_content_source',
//   Ribbons = 'ribbons',
// }

export enum HeroBannerContent {
  HeroA = 'hero_a',
  HeroB = 'hero_b',
  NAME = 'hero_banner_content',
}
